import { render, staticRenderFns } from "./ExtensionsList.vue?vue&type=template&id=cc9fd8ee&"
import script from "./ExtensionsList.vue?vue&type=script&lang=js&"
export * from "./ExtensionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports